import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-inline-block" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "colspan",
  class: "me-2"
}, "Colspan:", -1)
const _hoisted_4 = { class: "d-inline-block mx-1" }
const _hoisted_5 = { class: "d-inline-block mx-1" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "decimalPlaces",
  class: "mx-2"
}, "Decimals:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Divider = _resolveComponent("Divider")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_ToggleButton = _resolveComponent("ToggleButton")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Divider, { layout: "vertical" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_InputNumber, {
          disabled: !_ctx.canApplyColspan,
          style: {"width":"80px"},
          showButtons: true,
          fluid: true,
          min: 1,
          max: _ctx.getMaxColSpan(),
          modelValue: _ctx.localSettings.colspan,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localSettings.colspan) = $event)),
          modelModifiers: { number: true },
          onInput: _ctx.updateSettings
        }, null, 8, ["disabled", "max", "modelValue", "onInput"])
      ])
    ]),
    _createVNode(_component_Divider, { layout: "vertical" }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_ToggleButton, {
        disabled: !_ctx.canApplyPercentage,
        modelValue: _ctx.localSettings.isPercentage,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localSettings.isPercentage) = $event)),
        onLabel: "%",
        offLabel: "%",
        onChange: _ctx.updateSettings
      }, null, 8, ["disabled", "modelValue", "onChange"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_Dropdown, {
          disabled: !_ctx.canApplyDecimalPlaces,
          modelValue: _ctx.localSettings.decimalPlaces,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localSettings.decimalPlaces) = $event)),
          options: _ctx.decimalOptions,
          optionLabel: "name",
          optionValue: "value",
          style: {"width":"100px"},
          onChange: _ctx.updateSettings,
          panelStyle: {'width': '200px'}
        }, null, 8, ["disabled", "modelValue", "options", "onChange"])
      ])
    ])
  ], 64))
}